// extracted by mini-css-extract-plugin
export var focusVisible = "MqIyXrRcvmdSzs7rM3Wm";
export var openReturn = "mDDbZ_KvQXN1fb2imPUG";
export var root = "TL49Y9ZpIKp1HvPrRhzJ";